import {
    GET_BARGAN_PAYMENT_TERM_REQUEST,
    GET_BARGAN_PAYMENT_TERM_ERROR,
    GET_BARGAN_PAYMENT_TERM_SUCCESS,
    ADD_BARGAN_PAYMENT_TERM_REQUEST,
    ADD_BARGAN_PAYMENT_TERM_ERROR,
    ADD_BARGAN_PAYMENT_TERM_SUCCESS,
    UPDATE_BARGAN_PAYMENT_TERM_REQUEST,
    UPDATE_BARGAN_PAYMENT_TERM_ERROR,
    UPDATE_BARGAN_PAYMENT_TERM_SUCCESS,
    DELETE_BARGAN_PAYMENT_TERM_REQUEST,
    DELETE_BARGAN_PAYMENT_TERM_ERROR,
    DELETE_BARGAN_PAYMENT_TERM_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getAdminBarganTerm = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_BARGAN_PAYMENT_TERM_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/AdminBarganPaymentTerm`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_BARGAN_PAYMENT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_BARGAN_PAYMENT_TERM_ERROR,
                payload: error.response,
            });
        });
};

export const addAdminBarganTerm = (token, data, menu_id) => (dispatch) => {



    dispatch({ type: ADD_BARGAN_PAYMENT_TERM_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/AdminBarganPaymentTerm`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { term_description: data.barganPaymentTermName, is_active: data.check, menu_id },
    })
        .then((response) => {

            return dispatch({ type: ADD_BARGAN_PAYMENT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_BARGAN_PAYMENT_TERM_ERROR,
                payload: error.response,
            });
        });
};

export const updateAdminBarganTerm = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_BARGAN_PAYMENT_TERM_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/AdminBarganPaymentTerm/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { term_description: data.barganPaymentTermName, is_active: data.check },
    })
        .then((response) => {

            return dispatch({ type: UPDATE_BARGAN_PAYMENT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_BARGAN_PAYMENT_TERM_ERROR,
                payload: error.response,
            });
        });
};

export const deleteAdminBarganTerm = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_BARGAN_PAYMENT_TERM_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/AdminBarganPaymentTerm/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {

            return dispatch({ type: DELETE_BARGAN_PAYMENT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_BARGAN_PAYMENT_TERM_ERROR,
                payload: error.response,
            });
        });
};
